export const isEqual = (s1 = '', s2 = '', ignoreCase = false) => (ignoreCase
  ? s1.toUpperCase() === s2.toUpperCase()
  : s1 === s2);
